import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { loadState } from "../../stores/store";
import Sider from "antd/es/layout/Sider";
import { Button, Menu } from "antd";
import {
    CalendarOutlined,
    ContainerOutlined,
    LogoutOutlined,
    ProfileOutlined,
    ShopOutlined,
    TeamOutlined,
    UserOutlined,
    DollarCircleOutlined,
    SettingOutlined,
    BarChartOutlined,
    FormOutlined,
    ShoppingOutlined,
    HomeOutlined,
    EditOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    CloseOutlined
} from "@ant-design/icons";
import { useSettings } from "../../contexts/settingsContext";

const Sidebar = ({ collapsed, expanded, onExit }) => {
    const location = useLocation();
    const state = loadState();
    const { state: settings } = useSettings();
    const role = state.user.role;
    // Hide the global sidebar for judge users (judges have a focused grading UI)
    if (role === 'judge') return null;

    const items = [
        // { key: "/statistics", label: "Statistics", icon: <BarChartOutlined />, roles: ["admin"] },
        { key: "/contestants", label: "Solo Entries", icon: <UserOutlined />, roles: ["admin", "guardian"] },
        { key: "/applications", label: "Applications", icon: <ContainerOutlined />, roles: ["contestant"] },
        { key: "/groups", label: "Group Entries", icon: <TeamOutlined />, roles: ["admin", "guardian"] },
        { key: "/entries", label: "Contestants", icon: <ContainerOutlined />, roles: ["admin"] },
    { key: "/events", label: "Events", icon: <FormOutlined />, roles: ["admin"] },
        { key: '/invoice', label: "Invoice", icon: <DollarCircleOutlined />, roles: ["contestant"] },
        // { key: '/schedule', label: "Schedule", icon: <CalendarOutlined />, roles: ["contestant"] },
        // { key: "/passes", label: "Passes", icon: <ShopOutlined />, roles: ["contestant", "guardian", "admin"] },
        // { key: "/merchandise", label: "Merchandise", icon: <ShoppingOutlined />, roles: ["contestant", "guardian", "admin"] },
        { key: '/profile', label: "Profile", icon: <ProfileOutlined />, roles: ["contestant"] },
        // { key: '/venues', label: "Venues", icon: <HomeOutlined />, roles: ["admin"] },
    { key: '/scheduling', label: "Scheduling", icon: <CalendarOutlined />, roles: ["admin"] },
    { key: '/grading', label: "Grading", icon: <EditOutlined />, roles: ["admin"] },
    { key: '/judging', label: "Judging", icon: <EditOutlined />, roles: ["judge"] },
        { key: '/settings', label: "Settings", icon: <SettingOutlined />, roles: ["admin"] },
    ];

    const filteredItems = items
        .filter(item => !item.roles || item.roles.includes(role))
        .map(item => ({
            ...item,
            label: role === "contestant" ? `My ${item.label}` : item.label
        }));

    return (
        <>
            <Sider className={`sider ${expanded ? 'expanded' : ''}`} theme="light" collapsed={collapsed}>
                <div className="sticky-container">
                    <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
                    <Button type="text" size="large" className="sider_close_button" style={{ width: '60px', height: '60px' }} icon={<CloseOutlined/>} onClick={onExit}></Button>

                    </div>
                    <div className="sidebar-header">
                        {settings.imagePath && <img src={settings.imagePath} alt="logo" className="logo" />}
                    </div>
                    <Menu
                        mode="vertical"
                        selectedKeys={[location.pathname]}
                        items={filteredItems.map((item) => ({
                            ...item,
                            label: <NavLink key={item.key} to={item.key} onClick={onExit}>{item.label}</NavLink>,
                        }))}
                    />
                </div>
            </Sider>
            {expanded && <div className="sidebar-overlay" onClick={onExit}/>}
        </>
    );
};

export default Sidebar;  
